<div class="bg-white border rounded-lg grid grid-cols-4">

    <div class="p-5 border-r">
        <img class="w-full h-[9rem] bg-zinc-100 rounded-md" src="assets/dummy_thumbnail.png" alt="">
        <h2 class="text-lg font-medium capitalize mt-3 mb-1 line-clamp-2">introduction to C++ programming</h2>
        <span class="text-sm text-zinc-500 line-clamp-3"> Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Placeat quo consequatur veritatis sunt velit molestiae quas fugit magni minima similique explicabo
            asperiores fuga, magnam harum et quaerat temporibus nam. Sint. </span>
    </div>

    <div class="col-span-3 p-5">

        <div role="tablist" class="tabs tabs-bordered capitalize">
            <a role="tab" class="tab">class 5A</a>
            <a role="tab" class="tab tab-active">class 6A</a>
            <a role="tab" class="tab">class 6B</a>
            <a role="tab" class="tab">class 9B</a>
        </div>


        <div class="my-5 flex justify-between items-center">
            <div class="flex items-center gap-3"><span class="font-semibold text-zinc-500">56%</span><progress class="progress w-[30rem]" value="56" max="100"></progress></div>
            <div class="flex gap-3 items-center">
                <button class="btn btn-circle btn-sm" (click)="scrollPrev()"><i class="ri-arrow-left-s-line"></i></button>
                <button class="btn btn-circle btn-sm" (click)="scrollNext()"><i class="ri-arrow-right-s-line"></i></button>
            </div>
        </div>
        
        <div class=" flex justify-center relative">

            <div #embla class="embla overflow-hidden p-8 ">
                <div class="embla__container flex items-center gap-1 snap-x snap-mandatory ]">
                  @for (i of data; track $index) {
                    <div (click)="scrollTo($index)"
                      class="embla__slide snap-center transform-gpu origin-center shrink-0 w-[11rem] transition-transform duration-300"
                      [ngClass]="{
                        'scale-100': selectedIndex !== $index,
                        'scale-[1.2] z-10': selectedIndex-1 === $index || selectedIndex+1 === $index,
                        'scale-[1.35] z-20 w-[15rem] bg-whitebg-white bg-zinc-50 border rounded-lg p-1': selectedIndex === $index,
                      }"
                    >
                      <a>
                        <div class="relative w-full h-[6rem] rounded-md overflow-hidden">
                          <img class="w-full h-full object-cover" [src]="i.img" alt="" />
                          <span
                            class="absolute inset-0 flex justify-center items-center text-white text-2xl"
                            [ngClass]="{
                              'bg-black/70 ': !i.is_active,
                              'bg-black/10': i.is_active
                            }"
                          >
                          <i class="{{ i.is_active ? 'ri-play-fill' : 'ri-lock-fill' }}"></i>
                          </span>
                        </div>
                        <p
                          class="capitalize text-center text-xs line-clamp-1 font-medium mt-2 transition-opacity duration-300"
                          [ngClass]="{
                            'text-zinc-700 opacity-100': selectedIndex === $index,
                            'text-zinc-500 opacity-0': selectedIndex !== $index
                          }"
                        >
                          {{ i.title }}
                        </p>
                      </a>
                    </div>
                  }
                </div>
              </div>
              

              








        </div>


    </div>


</div>